import { useScroll } from './hooks/useScroll';
import { WineModel, WineWidgetModel } from '../../models/WineWidgetModel';
import WineScrollbarHeader from './Scrollbar/WineScrollbarHeader';
import WinesContentWithScrollbar from './Scrollbar/WineWithScrollbar';
import { previewScrollbar } from 'shared-widget-components/src/components/preview/previewScrollbar';
import { WineLink } from './Scrollbar/WineLink';

interface WinesComponentProps {
  languageCode: string;
  item: WineModel;
  wineList: WineWidgetModel[];
}

/**
 * WinesPreview component
 * @param languageCode - language code
 * @param item - wine model
 * @param wineList - list of wines
 * @returns - WinesPreview component
 */

export const WinesPreview = ({ languageCode, item, wineList }: WinesComponentProps) => {
  const numberOfRenderedWines = item.renderedWines;
  const { isScrollbarVisible, scrollLeft, scrollRight, scrollbarContainerRef, scrollbarRef, isScrollableToLeft, isScrollableToRight } = useScroll({ wineList, numberOfRenderedWines });

  const getLanguageContent = () => {
    if (item.widgetTitle && item.widgetTitle[languageCode]) {
      const languageConent = item.widgetTitle[languageCode];
      return languageConent;
    }
    if (item.widgetTitle) return item.widgetTitle['hu'];
    return { title: '' };
  };

  return (
    <div className='flex flex-col items-center justify-center px-2 w-full previewScrollbar overflow-hidden min-[350px]:py-4 md:py-6 lg:py-10' style={{ background: item.backgroundColor }}>
      <style>{previewScrollbar}</style>
      <div className='w-full max-w-[1240px] mx-auto ' ref={scrollbarContainerRef}>
        <WineScrollbarHeader
          scrollBackward={scrollLeft}
          scrollForward={scrollRight}
          textColor={item.textColor}
          title={getLanguageContent().title}
          isScrollbarVisible={isScrollbarVisible}
          isScrollableToLeft={isScrollableToLeft}
          isScrollableToRight={isScrollableToRight}
        />
        <WinesContentWithScrollbar scrollbarRef={scrollbarRef} isScrollbarVisible={isScrollbarVisible} scrollbarColor={item.scrollbarColor} item={item} wineList={wineList} />
      </div>
      <div className='min-[350px]:flex md:hidden items-center justify-center text-center underline'>
        <WineLink textColor={item.textColor} />
      </div>
    </div>
  );
};
